var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { DefaultLoadingComponent } from './default-loading-component';
import React from 'react';
import { LoaderForTable } from './loaders/loader-table';
import { LoaderForHeaders } from './loaders/loader-headers';
import { LoaderForDialog } from './loaders/loader-dialog';
export var LoadersArray = [
    'questionSets',
    'caseTable',
    'caseTracking',
    'caseApplicant',
    'caseNotes',
    'applicantTable',
    'caseDetails',
    'caseSectionMenu',
    'clientTable',
    'cardClientDetails',
    'cardClientDownloads',
    'productTable',
    'illustrationDocumentsTable',
    'caseApplicantDocuments',
    'caseDocuments',
    'caseDeclerations',
    'caseFees',
    'caseSubmit',
    'caseSubmitSectionMenu',
];
export var loaderComponentConfig = {
    table: function (_a) {
        var props = __rest(_a, []);
        return React.createElement(LoaderForTable, __assign({}, props, { isLoading: props.isLoading, Component: props.Component }));
    },
    default: function (_a) { var _b; var props = __rest(_a, []); return !props.isLoading ? (_b = props.Component) !== null && _b !== void 0 ? _b : React.createElement(React.Fragment, null) : React.createElement(DefaultLoadingComponent, __assign({}, props)); },
    headers: function (_a) {
        var props = __rest(_a, []);
        return !props.isLoading ? props.Component : React.createElement(LoaderForHeaders, __assign({}, props));
    },
    dialog: function (_a) {
        var props = __rest(_a, []);
        return (!props.isLoading ? props.Component : React.createElement(LoaderForDialog, __assign({}, props)));
    },
    ruLoader: function (_a) {
        var props = __rest(_a, []);
        return props.Component;
    },
};
